import { JsonConvert, JsonConverter, JsonCustomConvert, JsonObject, JsonProperty } from "json2typescript";
import { BaseResponse } from "./base-response";
import { Role } from "./role";

@JsonConverter
export class UserConverter implements JsonCustomConvert<User>{
	serialize() { }
	deserialize(data: any): User {
		const jsonConvert: JsonConvert = new JsonConvert();
		return jsonConvert.deserializeObject(data, User);
	}
}

@JsonConverter
export class UserArrayConverter implements JsonCustomConvert<Array<User>>{
	serialize() { }
	deserialize(data: any): Array<User> {
		const jsonConvert: JsonConvert = new JsonConvert();
		return jsonConvert.deserializeArray(data, User);
	}
}

@JsonConverter
export class UserListConverter implements JsonCustomConvert<UserList>{
	serialize() { }
	deserialize(data: any): UserList {
		const jsonConvert: JsonConvert = new JsonConvert();
		return jsonConvert.deserializeObject(data, UserList);
	}
}

@JsonObject("User")
export class User {
    @JsonProperty("uuid", String, true)
    uuid: string = "";
    @JsonProperty("first_name", String, true)
    first_name: string = "";
    @JsonProperty("last_name", String, true)
    last_name: string = "";
    @JsonProperty("created_at", Number, true)
    created_at: number = 0;
    @JsonProperty("role", String, true)
    role: string = "";
    @JsonProperty("password", String, true)
    password: string = "";
    @JsonProperty("email", String, true)
    email: string = "";

    dto() {
        const dtoObj: any = {
            first_name: this.first_name,
            last_name: this.last_name,
            role: this.role
        };
        if (this.password) {
            dtoObj.password = this.password;
        }
        if (this.email) {
            dtoObj.email = this.email;
        }

        return dtoObj;
    }
}


@JsonObject("UserList")
export class UserList {
	@JsonProperty("count", Number, true)
	count: number = 0;
	@JsonProperty("data", UserArrayConverter, true)
	data: Array<User> = new Array<User>();
}

@JsonObject("UserData")
export class UserData extends BaseResponse {
	@JsonProperty("data", UserConverter, true)
	data: User = new User();
}

@JsonObject("UserListData")
export class UserListData extends BaseResponse {
	@JsonProperty("data", UserListConverter, true)
	data: UserList = new UserList();
}